let docEl = document.documentElement //获取整个页面
function setRemUnit() {
    let width = docEl.clientWidth  //网页面的宽度
    if(width >= 996){
        let rem = width / 192  //以 375 宽度为标准 375/37.5=10
        docEl.style.fontSize = rem + 'px' //一开始网页大小为10px，根据屏幕变大而变大
        console.log('rem',rem);
    }else{
        docEl.style.fontSize =3+ 'px' //一开始网页大小为10px，根据屏幕变大而变大
    }

}
setRemUnit() // 网页初始化执行函数
window.addEventListener('resize', setRemUnit) //坚听屏幕宽度变化执行函数setRenUnit